
































































import { Component, Prop, Vue } from "vue-property-decorator";
import { BTooltip } from "bootstrap-vue";
import { getFieldContent } from "@/helpers/utils";
import InitialsBadge from "./InitialsBadge.vue";
import GuideBalloon from "./GuideBalloon.vue";
import BaseModal from "@/layouts/components/BaseModal.vue";
import ClientGoals from "@/layouts/components/ClientGoals.vue";
import ConfirmationModal from "./ConfirmationModal.vue";
import clientAppModel from "@/api/client_app.model";
import goalsModel from "@/api/goals.model";
import { showErrorAlert, showSuccessAlert } from "@/helpers";

export type tagVariant = "primary" | "secondary" | "tertiary";

@Component({
	components: {
		"initials-badge": InitialsBadge,
		ConfirmationModal,
		GuideBalloon,
		BaseModal,
		ClientGoals,
		BTooltip,
	},
})
export default class CustomUserCard extends Vue {
	@Prop({ default: () => [] }) cardData!: any;
	@Prop({ default: () => [] }) cardHeaders!: any;
	@Prop({ default: "" }) customClass!: string;
	@Prop({ default: true }) shouldShowIsActiveIcon: boolean;
	@Prop({ default: "primary" }) variant!: tagVariant;
	@Prop({ default: (event: Event) => null }) onClick!: (event: Event, buttonAction?: string) => void;
	@Prop({ default: false }) shouldShowGoals: boolean;

	getFieldContent = getFieldContent;
	primaryStyle = "text-journey-black font-bold";
	secondaryStyle = "text-journey-gray font-bold text-sm";

	goalsTitle = "Metas de saúde do paciente";
	goalsButtons = [
		{
			icon: "change-icon.svg",
			variant: "tertiary",
			buttonAction: this.openNewAccessCodeCreationModal,
			label: "Gerar novo código",
		},
		{
			icon: "copy-icon.svg",
			variant: "tertiary",
			buttonAction: this.onClickCopyGoals,
			label: "Copiar dados de acesso",
		},
	];

	baseCss =
		"flex flex-row pl-2.5 pr-2 py-2.5 shadow-md bg-journey-white justify-start gap-x-4 items-center cursor-pointer rounded-r-md";
	primaryCss = "border-l-4 border-journey-yellow";
	secondaryCss = "border-l-4 border-journey-orange";
	tertiaryCss = "border-l-4 border-journey-blue";

	isNewAccessCodeConfirmationModalOpen = false;
	isNewAccessCodeCreationModalOpen = false;
	isModalGoalsOpen = false;
	clientGoals = null;

	get cardStyle() {
		let baseStyles = [this.baseCss];
		switch (this.variant) {
			case "primary":
				baseStyles.push(this.primaryCss);
				break;
			case "secondary":
				baseStyles.push(this.secondaryCss);
				break;
			case "tertiary":
				baseStyles.push(this.tertiaryCss);
				break;
		}
		return baseStyles;
	}

	async openGoalsModal() {
		if (!this.shouldShowGoals) return;

		try {
			if (!this.cardData.accessCode) {
				//Gera novo acesso se cliente não possui
				const response = await clientAppModel.getNewAccessCode(this.cardData.id);
				this.cardData.accessCode = response;
			}

			const clientGoals = await goalsModel.getGoalsInformations(
				this.cardData.id,
				this.cardData.cpf,
				this.cardData.accessCode,
			);

			this.clientGoals = clientGoals;
			this.isModalGoalsOpen = true;
		} catch (error) {
			showErrorAlert((<any>error)?.message ?? "Ocorreu um erro. Tente novamente.");
		}
	}

	onClickCopyGoals() {
		navigator.clipboard.writeText(
			"Link: " +
				document.location.origin +
				`/goals-panel/${this.cardData.id}` +
				` | Código de acesso: ${this.cardData.accessCode}`,
		);
		showSuccessAlert("", "URL da página de metas de saúde do paciente copiada.");
	}

	openNewAccessCodeCreationModal() {
		this.isNewAccessCodeConfirmationModalOpen = true;
	}

	closeNewAccessCodeCreationModal() {
		this.isNewAccessCodeConfirmationModalOpen = false;
	}

	async saveAction() {
		try {
			const response = await clientAppModel.getNewAccessCode(this.cardData.id);
			this.cardData.accessCode = response;
			showSuccessAlert("", "Novo código de acesso gerado e disponível através do botão de cópia.");
		} catch (error) {
			showErrorAlert((<any>error)?.message ?? "Ocorreu um erro. Tente novamente.");
		}
	}

	closeModal() {
		this.isModalGoalsOpen = false;
	}

	handleClick(event: Event) {
		event.preventDefault();
		if (this.onClick && typeof this.onClick === "function") {
			this.onClick(event, this.cardData);
		}
	}
}
